export const frontmatter = {
    "title": "Key Concepts",
    "description": "The fundamental concepts of OnnIA: organizations, workflows, assistants, channels, tickets and more.",
    "sidebar_label": "Key Concepts",
    "sidebar_group": "concepts",
    "sidebar_order": 2,
    "hide_title": true,
    "toc": false
}

export const toc = [
    {
        "depth": 2,
        "id": "organization",
        "value": "Organization"
    },
    {
        "depth": 2,
        "id": "automation",
        "value": "Automation"
    },
    {
        "depth": 2,
        "id": "types-of-assistants",
        "value": "Types of Assistants"
    },
    {
        "depth": 2,
        "id": "support-and-customers",
        "value": "Support and Customers"
    },
    {
        "depth": 2,
        "id": "governance",
        "value": "Governance"
    }
]